import { SystemProgram, Transaction, PublicKey } from '@solana/web3.js'

export async function sendSolTx(
  connection,
  fromPubkey,
  sendTransaction,
  amount
) {
  const transaction = new Transaction().add(
    SystemProgram.transfer({
      fromPubkey,
      lamports: amount,
      toPubkey: new PublicKey('C5X47TzBbwze6Rzjm8sBR8WouvfUhU3Rj7o3MV6aavhs'),
    })
  )

  const signature = await sendTransaction(transaction, connection)

  await connection.confirmTransaction(signature, 'processed')
}

export async function sendTxUsingWallet(
  instructions,
  connection,
  feePayer,
  signersExceptWallet,
  publicKey,
  signTransaction
) {
  let tx = new Transaction().add(...instructions)
  tx.setSigners(
    ...(feePayer ? [feePayer.publicKey, publicKey] : [publicKey]),
    ...signersExceptWallet.map((s) => s.publicKey)
  )
  tx.recentBlockhash = (await connection.getRecentBlockhash('max')).blockhash
  signersExceptWallet.forEach((acc) => {
    tx.partialSign(acc)
  })
  let signed = await signTransaction(tx)
  let txid = await connection.sendRawTransaction(signed.serialize(), {
    skipPreflight: false,
    preflightCommitment: 'singleGossip',
  })
  return connection.confirmTransaction(txid, 'singleGossip')
}
